export default {
  state: {
    showMessage: false,
    messageOption: {
      contents: '',
      color: ''
    }
  },
  mutations: {
    SET_SHOW_MESSAGE: (state, flag) => {
      state.showMessage = flag
    },
    SET_MESSAGE_OPTION: (state, option) => {
      state.messageOption = option
    }
  },
  actions: {
    SetShowMessage({ commit }, flag) {
      commit('SET_SHOW_MESSAGE', flag)
    },
    SetMessageOption({ commit }, option) {
      commit('SET_MESSAGE_OPTION', option)
    }
  }
}
